module.exports = __webpack_public_path__ + "img/joinus-8.4fee0ac8.png";